import axios from '@/plugins/axios';

export const getUserCustomers = async (userId, channel) => {
  const { data } = await axios.get(`/hierarchy/users/${userId}/customers`, {
    params: { channel },
  });

  return data?.data;
};

export const getUserDescendants = async (userId, channel) => {
  const { data } = await axios.get(`/hierarchy/users/${userId}/descendants`, {
    params: { channel },
    noCancelRequest: true,
  });

  return data?.data;
};

export const getUserRelatedUsers = async (userId) => {
  const { data } = await axios.get(`/hierarchy/users/${userId}/related`);

  return data?.data;
};
